import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRouteAssemblyItemService } from '../../../../../api/elite/routes/assembly.service';

@Injectable()
export class HosesAssemblyItemApiService {
  private readonly apiItemServiceRouter = inject(ApiRouteAssemblyItemService);

  searchItems(search = ''): Observable<{ id: number; title: string }[]> {
    return this.apiItemServiceRouter.searchItems(search).pipe(
      map((items) => {
        return items.map((item) => ({ id: item.id, title: item.title }));
      })
    );
  }
}
